'use strict';

var React = require('react'),
    config = require('config'),
    UserStore = require('../stores/UserStore'),
    AnalyticsSources = require('../constants/AnalyticsSources'),
    AboutSection = require('../organisms/AboutSection'),
    ShortSignUp = require('../molecules/ShortSignUp'),
    ShortLogin = require('../molecules/ShortLogin'),
    Link = require('../atoms/Link'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    getThumbnailUrl = require('../utils/getThumbnailUrl'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    cx = require('react/lib/cx'),
    { PropTypes } = React;

require('./AboutSocialProofSection.less');

const DELAY = 7000;
const tweets = [{
  text: 'Future platform for all visual minds! Key differences from @tumblr and @wordpressdotcom make their mark. #stampsy @hellostampsy',
  sourceUrl: '//twitter.com/artshaman/status/565493279509467138',
  user: {
    name: 'Matthew Stone',
    profileUrl: '//twitter.com/artshaman',
    thumbnailUrl: '//stampsy-eu-1.s3.amazonaws.com/uploads/02/23/2015/8fcd23a0-eecb-49d1-98c8-8f7372eb99a3.jpg'
  }
}, {
  text: 'I love how @HelloStampsy makes my photos look better than they actually are. It became my website to show my work to potential clients.',
  sourceUrl: '//twitter.com/LauraZalenga/status/565776531658924032',
  user: {
    name: 'Laura Zalenga',
    profileUrl: '//stampsy.com/user/13910',
    thumbnailUrl: '//stampsy-eu-1.s3.amazonaws.com/uploads/production/25/06/2014/user/13910/f80b9d12-ba1f-4381-9609-a3462e0bac9b.jpg'
  }
}, {
  text: 'stampsy.com  (@HelloStampsy) is a great tool for visual stories. Give it a try! It\'s a good way to fill your daily inspiration.',
  sourceUrl: '//twitter.com/Guitouxx/status/565619914770485249',
  user: {
    name: 'Guillaume Tomasi',
    profileUrl: '//stampsy.com/user/17933',
    thumbnailUrl: '//stampsy-eu-1.s3.amazonaws.com/uploads/08/28/2014/user/17933/3cccdb7b-4a0e-4a89-be41-ccf4c1c6887d.png'
  }
}, {
  text: 'If you haven\'t heard of @HelloStampsy yet check it out! Lovely full screen interface, see my portfolio here https://stampsy.com/user/17816',
  sourceUrl: '//twitter.com/tim_bowditch/status/565774606615580672',
  user: {
    name: 'Tim Bowditch',
    profileUrl: '//stampsy.com/user/17816',
    thumbnailUrl: '//stampsy-eu-1.s3.amazonaws.com/uploads/09/02/2014/user/17816/d2bc4948-2c1d-4c41-9d6c-da168e0e480a.jpg'
  }
}, {
  text: 'It\'s about time: a site for #photography with #stories behind. Clever in its great yet simple design: https://stampsy.com/about @HelloStampsy',
  sourceUrl: '//twitter.com/GBenard/status/565628470156603392',
  user: {
    name: 'Gonzalo W. Bénard',
    profileUrl: '//stampsy.com/user/16102',
    thumbnailUrl: '//stampsy-eu-1.s3.amazonaws.com/uploads/production/28/11/2014/user/16102/scale_crop/512x512/91f0801f-bdd7-4fd6-8c4a-c8a3cef33316.jpg'
  }
}, {
  text: 'Discover @HelloStampsy Great #photography #platform Huge visibility and many contributors from all around the world! https://stampsy.com/',
  sourceUrl: '//twitter.com/giangallucci/status/565630498085806080',
  user: {
    name: 'Gianfranco Gallucci',
    profileUrl: '//stampsy.com/user/16873',
    thumbnailUrl: '//stampsy-eu-1.s3.amazonaws.com/uploads/07/21/2014/user/16873/7cae50fe-82d7-4973-931f-ed270125485e.jpg'
  }
}, {
  text: 'I\'ve been keeping my eye on @HelloStampsy for a while. Quality photo presentations. They\'ve updated, great new look. https://stampsy.com',
  sourceUrl: '//twitter.com/MOSSLESS/status/568409756831911936',
  user: {
    name: 'Romke Hoogwaerts',
    profileUrl: '//stampsy.com/user/10169',
    thumbnailUrl: '//stampsy-eu-1.s3.amazonaws.com/uploads/02/23/2015/d05498a6-466d-4517-bcb1-59f39a453f6c.png'
  }
}];

var AboutSocialProofSection = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin],

  propTypes: {
    layout: PropTypes.any.isRequired,
    active: PropTypes.bool.isRequired
  },

  getInitialState() {
    return {
      visibleTweetIndex: 0
    };
  },

  componentDidMount() {
    this.interval = setInterval(this.switchTweet, DELAY);
  },

  componentWillReceiveProps(nextProps) {
    if (nextProps.active && !this.props.active) {
      clearInterval(this.interval);
      this.interval = setInterval(this.switchTweet, DELAY);
    }
  },

  componentWillUnmount() {
    clearInterval(this.interval);
  },

  getCSSModifiers() {
    return {
      inactive: !this.props.active
    };
  },

  render() {
    const isAuthenticated = UserStore.isAuthenticated();

    return (
      <AboutSection layout={this.props.layout}
                    active={this.props.active}
                    title='Connect with the evergrowing Stampsy Community!'
                    backgroundColor='#38c591'
                    color='white'>
        <div className={this.getClassName()}>
          {!isAuthenticated &&
            <div className='AboutSocialProofSection-signUpWrapper'>
                {config.signUpEnabled ?
                <ShortSignUp color='light'
                             source={AnalyticsSources.ABOUT_PAGE_WELCOME} />
                :
                <ShortLogin color='light'
                             source={AnalyticsSources.ABOUT_PAGE_WELCOME} />
                }
            </div>
          }

          <div className='AboutSocialProofSection-tweets'>
            {tweets.map(this.renderTweet)}
          </div>
        </div>

        <div className="Footer Footer-about-page">
          <ul className='Footer-list'>
            <li className='Footer-item'>
              <Link to='terms'
                    underline='never'>
                Terms&nbsp;of&nbsp;Service
              </Link>
            </li>

            <li className='Footer-item'>
              <Link to='privacy'
                    underline='never'>
                Privacy&nbsp;Policy
              </Link>
            </li>

            <li className='Footer-item'>
              <Link href='https://www.facebook.com/HelloStampsy'
                    target='_blank'
                    underline='never'>
                Facebook
              </Link>
            </li>

            <li className='Footer-item'>
              <Link href='https://twitter.com/HelloStampsy'
                    target='_blank'
                    underline='never'>
                Twitter
              </Link>
            </li>

            <li className='Footer-item'>
              <Link href='https://www.pinterest.com/HelloStampsy/'
                    target='_blank'
                    underline='never'>
                Pinterest
              </Link>
            </li>
          </ul>
        </div>

      </AboutSection>
    );
  },

  renderTweet(tweet, index) {
    const { visibleTweetIndex } = this.state;
    const className = cx({
      'AboutSocialProofSection-tweet': true,
      'AboutSocialProofSection-tweet--hidden': index !== visibleTweetIndex
    });
    const devicePixelRatio = (typeof window !== 'undefined') ? window.devicePixelRatio : 1;

    return (
      <div className={className} key={index}>
        <Link href={tweet.sourceUrl}
              className='AboutSocialProofSection-message'
              target='_blank'
              underline='never'>
          {tweet.text}
        </Link>

        <div className='AboutSocialProofSection-author'>
          <a className='AboutSocialProofSection-authorPic'
             href={tweet.user.profileUrl}
             title={tweet.user.name}
             target='_blank'>
            <img key={tweet.user.thumbnailUrl}
                 alt={tweet.user.name}
                 src={getThumbnailUrl({ url: tweet.user.thumbnailUrl }, {
                   mode: 'scale_crop',
                   width: 44 * Math.round(devicePixelRatio)
                 })} />
          </a>
          <Link href={tweet.user.profileUrl}
                title={tweet.user.name}
                target='_blank'
                underline='never'
                bold>
            {tweet.user.name}
          </Link>
        </div>
      </div>
    );
  },

  switchTweet() {
    this.setState({
      visibleTweetIndex: (this.state.visibleTweetIndex + 1) % tweets.length
    });
  }
});

module.exports = AboutSocialProofSection;



/** WEBPACK FOOTER **
 ** ./organisms/AboutSocialProofSection.jsx
 **/